import { PermissionT } from "../types";

export const projectsView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "projects_view");
  return !!p;
};

export default projectsView;
